export enum Radii {
  NONE = 'none',
  XS = 'xs',
  SM = 'sm',
  BASE = 'base',
  MD = 'md',
  LG = 'lg',
  XL = 'xl',
  '2XL' = '2xl',
  '3XL' = '3xl',
  '4XL' = '4xl',
  FULL = 'full',
  CIRCLE = 'circle',
  ROUNDED = 'rounded',
}
